export type EmployeeType = 'teachers' | 'drivers' | 'masters';

export function isEmployeeType(value: string | null): value is EmployeeType {
    if (!value) return false;
    return ['teachers', 'drivers', 'masters'].includes(value);
}